export default __webpack_public_path__ + "933811743ecce4b1650e8629896a63ea.svg";